import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useFieldArray } from 'react-hook-form'
import { Form, Button } from 'react-bootstrap'

import ActividadesSecundarias from './ActividadesSecundarias'
import CustomSucursal from './CustomSucursal'
import { useAppendOne } from './Hooks'

function Sucursales({ show, actividades, actividadesiibb, name }) {
  const { fields, append, remove } = useFieldArray({
    name
  })
  const location = useLocation()

  useAppendOne(show, fields, append, {
    domicilio_calle: '',
    domicilio_numero: '',
    domicilio_piso: '',
    codigo_postal: '',
    localidad: '',
    fecha_inicio: '',
    puntos_de_venta: []
  })

  useEffect(() => {
    let posible = true

    if (posible && !show && fields.length > 0) {
      fields.map((f) => remove(0))
    }
    return () => {
      posible = false
    }
  }, [show, fields, remove])

  return show ? (
    <>
      {fields.map((field, index) => (
        <React.Fragment key={index}>
          <h6 className="text-muted text-normal text-uppercase">
            Actividad principal en sucursal {name === 'externas' && 'externa'}{' '}
            {index + 1}
          </h6>

          <CustomSucursal
            label="Domicilio de la sucursal"
            name={name}
            index={index}
            field={field}
            remove={remove}
            visualizar={location?.state?.visualizarDatos}
            modificar={location?.state?.modificarDatos}
            location={location}
            actividades={actividades}
            actividadesiibb={actividadesiibb}
          />

          {name !== 'externas' && (
            <ActividadesSecundarias
              actividades={actividades}
              actividadesiibb={actividadesiibb}
              name={name}
              index={index}
            />
          )}

          <hr className="my-2" />
        </React.Fragment>
      ))}

      <Form.Row>
        <Button
          variant="outline-primary"
          className="btn-block my-4"
          onClick={() => append({})}
          disabled={location?.state?.visualizarDatos}
        >
          Agregar sucursal
        </Button>
      </Form.Row>
    </>
  ) : (
    <></>
  )
}

export default Sucursales
